import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import TeamItem from './TeamItem';
import { InputGroup, Icon, Input } from "rsuite";
import { Modal, Avatar, Uploader, Button } from "rsuite";
import { Link } from "react-router-dom";
import {
  deleteServiceType,
  addServiceTypeFiles,
} from "../../../actions/settingActions";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "../../../validations/isEmpty";

const styles = {
  width: 300,
  marginBottom: 10,
};

function TeamsFeed({ serviceTypes, onEdit }) {
  return (
    <div className="treks-list__block">
      {/* <div className="treks-list__search">
                <InputGroup inside style={styles}>
                    <Input 
                     onChange={(val)=>onChange(val)}    
                    />
                    <InputGroup.Button>
                        <Icon icon="search" />
                    </InputGroup.Button>
                </InputGroup>
            </div> */}
      <div className="treks-list__header trek-grid">
        <span className="name">Name</span>
        <span className="price text-center">Handle</span>
        <span className="edit text-center">Edit</span>
        <span className="delete text-center">Delete</span>
      </div>
      <div className="treks-list__items">
        {serviceTypes && serviceTypes.map((team) => <TourItem team={team} />)}
      </div>
    </div>
  );
}

const TourItem = (props) => {
  const { team, onEdit } = props;
  const [op, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [pic, setPic] = useState(null);

  const close = () => {
    setShow(false);
  };

  const open = () => {
    setShow(true);
  };

  const closeMod = () => {
    setOpen(false);
  };

  const openmod = () => {
    setOpen(true);
  };
  const styles = {
    width: 100,
    height: 100,
  };
  const uploadPic = () => {
    if (isEmpty(pic)) {
      return false;
    }
    const img = new FormData();
    const asd = pic[pic.length - 1].blobFile;
    img.append("image", asd);
    dispatch(addServiceTypeFiles(team.id, img));
    setPic([]);
    close();
    // debugger
  };

  const dispatch = useDispatch();
  return (
    <div className="trek-item trek-grid">
      <div onClick={() => openmod()} className="trek-item__days text-center">
        {team?.name}
      </div>
      <div className="trek-item__days text-center">{team?.handle}</div>
      <Modal backdrop={true} show={op} onHide={closeMod}>
        <Modal.Header>
          <Modal.Title>Tour Package Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="team-details">
            <div className="team-image">
              {team.image ? (
                <Avatar src={team.image} />
              ) : (
                <Avatar size="lg">{team.name}</Avatar>
              )}
              <div className="team-upload">
                <Uploader
                  multiple={false}
                  fileListVisible={false}
                  // defaultFileList={team.image}
                  listType="picture"
                  autoUpload={false}
                  onChange={(image) => {
                    setPic(image);
                  }}
                >
                  <button style={styles}>
                    {!isEmpty(pic) ? (
                      <img
                        src={URL.createObjectURL(pic[pic.length - 1].blobFile)}
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      <Icon icon="avatar" size="5x" />
                    )}
                  </button>
                </Uploader>
                <Button onClick={() => uploadPic()} appearance="primary">
                  Upload Image
                </Button>
              </div>
            </div>
            <div className="team-list">
              <div className="team-name">
                <h2>{team?.name}</h2>
                <span>{team?.handle}</span>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={closeMod} appearance="primary">
            Ok
          </Button>
          <Button onClick={closeMod} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <div className="trek-item__days text-left">
                {team.short}
            </div> */}
      {/* <div className="trek-item__days text-center">
                {team.details}
            </div> */}
      <div onClick={() => onEdit(team)} className="trek-item__edit text-center">
        <Icon icon="edit" size="lg" color="red" />
      </div>
      <div onClick={open} className="trek-item__delete text-center">
        <Icon icon="minus-square" size="lg" color="blue" />
      </div>

      <Modal backdrop="static" show={show} onHide={close} size="xs">
        <Modal.Body>
          <Icon
            icon="remind"
            style={{
              color: "#ffb300",
              fontSize: 24,
            }}
          />
          {"  "}
          Are you sure, You want to delete this trek region?
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              dispatch(deleteServiceType(team.id));
              close();
            }}
            appearance="primary"
          >
            Ok
          </Button>
          <Button onClick={close} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

TeamsFeed.propTypes = {
  teams: PropTypes.array.isRequired,
};

export default TeamsFeed;
